import { FC } from 'react'
import { Address } from 'graphql/types'
import ColumnsList from 'components/ColumnsList'
import SectionHeader from 'components/SectionHeader'
import {
  neighborhoodCondominiumEvent,
  neighborhoodCondominiumCollapseEvent,
} from 'pages/regioes-atendidas/regiao/condominio/events'
import regionStyles from '../../../../Region.module.scss'

export type TProps = {
  condominium: string
  address: Address
  items: Array<{
    name: string
    nameSlug: string
  }>
}

const Condominiums: FC<TProps> = ({ condominium, address, items }) => {
  if (
    !address.stateSlug ||
    !address.citySlug ||
    !address.neighborhood ||
    !address.neighborhoodSlug
  )
    return null

  const regionUrl = `/regioes-atendidas/${address.stateSlug}/${address.citySlug}/${address.neighborhoodSlug}`
  const MAX_VISIBLE_ITEMS = 15

  const sections = [
    {
      id: 'section-condominiums',
      columnsList: [
        {
          id: 'condominiums',
          columnsCount: 3,
          items: items?.map((item) => ({
            label: item.name,
            to: `${regionUrl}/${item.nameSlug}`,
            onClick: (url: string, label: string) =>
              neighborhoodCondominiumEvent({ url, label }),
          })),
          collapse:
            items?.length > MAX_VISIBLE_ITEMS
              ? {
                  expandedText: 'Ver menos condomínios',
                  collapsedText: 'Ver todos os condomínios',
                  maxItemsPerColumn: 5,
                  onClick: (isExpanded: boolean) =>
                    neighborhoodCondominiumCollapseEvent(
                      condominium,
                      isExpanded
                        ? 'Ver menos condomínios'
                        : 'Ver todos os condomínios',
                    ),
                }
              : undefined,
        },
      ],
    },
  ]

  return (
    <div className={regionStyles.ecPageRegionSection} id="CondominiumsSection">
      <SectionHeader
        title={{
          value: `Condomínios em ${address.neighborhood}`,
        }}
      />
      <ColumnsList sections={sections} />
    </div>
  )
}

export default Condominiums
